export default "__VITE_ASSET__13cb97ac__"